<script>
  import {
    Row,
    Col,
    Container,
    Button,
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Input,
    InputGroup,
    InputGroupAddon
  } from "sveltestrap";

  import { customAlphabet } from "nanoid/non-secure/index.js";

  import Chat from "./Chat.svelte";

  export let auth;
  export let firebase;

  let openChat;
  let chatSession;
  let isValid = "";

  const newRoom = () => {
    const nanoid = customAlphabet(
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
      28
    );

    chatSession = nanoid();

    const db = firebase.firestore();
    db.collection("chats")
      .doc(chatSession)
      .set({ messages: [] });

    openChat = true;
  };

  const checkSession = () => {
    if (chatSession === null || chatSession === "") {
      isValid = "is-invalid";
      return;
    }
    const db = firebase.firestore();
    const docRef = db.collection("chats").doc(chatSession);
    docRef
      .get()
      .then(doc => {
        if (doc.exists) openChat = true;
        else isValid = "is-invalid";
      })
      .catch(error => (isValid = "is-invalid"));
  };
</script>

<style>
  hr {
    background-color: darkgrey;
  }
</style>

{#if openChat}
  <Chat {chatSession} {firebase} {openChat} />
{:else}
  <Container class="min-vh-100">
    <Row class="min-vh-100">
      <Col class="align-self-center">
        <Card
          style="width: 18rem;"
          class="text-center mx-auto text-white"
          color="dark">
          <CardHeader>
            <CardTitle>
              <h3 class="mt-2">Eph Chat</h3>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <h5 class="mb-3">Join a Room</h5>
            <InputGroup>
              <Input
                name="roomCode"
                placeholder="Room Code"
                bind:value={chatSession}
                bind:class={isValid}
                on:keyup={e => {
                  isValid = '';
                  e.preventDefault();
                  if (e.key === 'Enter') checkSession();
                }} />
              <InputGroupAddon addonType="append">
                <Button
                  class="btn-block"
                  color="success"
                  on:click={() => checkSession()}>
                  →
                </Button>
              </InputGroupAddon>
            </InputGroup>

            <hr />
            <Button
              class="btn-block"
              color="success"
              on:click={() => newRoom()}>
              Create a Room
            </Button>
            <hr />
            <Button
              class="btn-block"
              color="danger"
              on:click={() => auth.signOut()}>
              Sign Out
            </Button>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
{/if}
